import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../../shared/assets/logos/ARBCOR_Text_only.png';

const Footer = () => {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-zinc-950 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Top row */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
          {/* Logo */}
          <img
            src={logo}
            alt="Arbcor"
            className="h-5 w-auto select-none pointer-events-none"
            style={{ filter: 'invert(1)' }}
            draggable="false"
            onContextMenu={(e) => e.preventDefault()}
          />

          {/* Nav links */}
          <div className="flex items-center gap-6">
            {['platform', 'features', 'industries', 'contact'].map((id) => (
              <button
                key={id}
                onClick={() => scrollTo(id)}
                className="text-zinc-500 text-sm hover:text-zinc-300 transition-colors capitalize"
              >
                {id}
              </button>
            ))}
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-zinc-800 my-8" />

        {/* Bottom row */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-zinc-500 text-xs tracking-wider">
            &copy; {new Date().getFullYear()} Arbcor Systems. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="text-zinc-500 text-xs hover:text-zinc-300 transition-colors">
              Privacy Policy
            </Link>
            <span className="text-zinc-700">|</span>
            <Link to="/eula" className="text-zinc-500 text-xs hover:text-zinc-300 transition-colors">
              EULA
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
